<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--ballot">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <div class="vtz-no-print">
        <app-progress-bar [routeName]="routeName"></app-progress-bar>
      </div>
      <h1 id="vtz-title-section-text" class="vtz-h1" i18n>
          Your ballot is ready to be printed.
        </h1>
      <div id="vtz-success-code-wrapper" class="vtz-success-code__wrapper">

        <div class="kit-list">
          <h2 id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
            Your Printing Kit contains 4 parts.
        </h2>
          <ol>
            <li i18n>Your Marked Ballot</li>
            <li i18n>The Secrecy Envelope</li>
            <li i18n>The Inner Affidavit Envelope</li>
            <li i18n>The Outside Mailing Envelope</li>
          </ol>
        </div>
        <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
            Please print out all pages and follow the instructions to create your secrecy, inner and mailing envelopes. Be sure to provide the required signatures.
          </p>
        <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
            Once you're finished, make sure to exit to end your session. Thank you for using the Voatz Web App!
          </p>
      </div>
      @if (isLoadingPdf) {
        <div class="loading-spinner">
          <div class="spinner-icon"></div>
          <pre>   </pre>Processing your ballot...
        </div>
      }
      @if (markedBallotReady) {
        <ngx-extended-pdf-viewer [src]="selectedDocumentName === 'BALLOT' ? ballotArray : envelopeArray" [showToolbar]="true" [showSidebarButton]="false"
          [showFindButton]="false" [showPagingButtons]="false" [showDrawEditor]="false" [showTextEditor]="false" [showHighlightEditor] = "false"
          [showZoomButtons]="false" [showPresentationModeButton]="false" [showOpenFileButton]="false" [showStampEditor] = "false"
          [showPrintButton]="false" [showDownloadButton]="false" [showSecondaryToolbarButton]="false"
          [showRotateButton]="false" [showHandToolButton]="false" [showSpreadButton]="false"
          [showPropertiesButton]="false" [showZoomButtons]="true" [height] ="'450px'" [zoom]="'page-width'"
        [language] = "locale"></ngx-extended-pdf-viewer>
      }

      <div id="vtz-actions" class="vtz-actions vtz-no-print">
        <div id="vtz-button-group" class="button-group button-group--sucess">
          <button id="cancel-button" class="button-secondary vtz--hide-mobile" (click)="showBallot()"
          i18n="Button label">SHOW BALLOT</button>
          @if (envelopeArray) {
            <button id="cancel-button" class="button-secondary vtz--hide-mobile" (click)="showEnvelope()"
            i18n="Button label">SHOW ENVELOPES</button>
          }
          <button id="cancel-button" class="button-primary vtz--hide-mobile" (click)="printActual()"
          i18n="Button label">PRINT {{selectedDocumentNameLocalize}}</button>
          @if (hasMoreBallots) {
            <button id="continue-button" class="button-primary" (click)="continue()">CONTINUE</button>
          }
          <button id="submit-button" class="button-primary" i18n="Button label" (click)="exit()" [disabled]="pdfsNotPrinted()">END SESSION</button>
        </div>
      </div>
      <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space extra-space" i18n> Note: Please un-check any "Print headers and footers" option on your print preview screen. Also, please set "Margins" to "None" on your print preview screen.</p>
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>

